import React from 'react';
import { AppBar, Toolbar } from '@material-ui/core';
import Menu from './Menu';
import TopHeader from './TopHeader';

const Header = () => (
  <AppBar position="static" color="primary">
    <Toolbar style={{ display: 'block', margin: '0', padding: '0' }}>
      <TopHeader />
      <Menu />
    </Toolbar>
  </AppBar>
);

export default Header;



// WEBPACK FOOTER //
// ./src/layout/Header.js